import Boolean from "../Boolean/Boolean";
const BooleanWithLabel = ({ labelAtTop = false, children, ...props }) => {
  return (
    <div>
      {labelAtTop && (
        <div className="mb-[1rem] font-semibold">
          {children}
        </div>
      )}
      <div className="flex items-center" style={{ height: labelAtTop ? "3.8rem" : undefined }}>
        <Boolean {...props} />
        {!labelAtTop && (
          <div className="text-small ml-3">
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default BooleanWithLabel;
